<template>
  <div class="full">
    <!-- <BGTemplate class="cg-layer full" @ready="(v) => { engine = v; }">
    </BGTemplate>
    <BlueBubbles v-if="engine && engine.renderer && engine.scene && engine.camera" :camera="engine.camera" :amount="20" :renderer="engine.renderer" :scene="engine.scene"></BlueBubbles> -->

    <div class="cg-layer center-v">
      <span v-if="state === 'connecting'">Connecting....</span>
      <span v-if="state === 'email-taken'" style="color : red;">Email is already registered....</span>

    </div>

  </div>
</template>

<script>
import * as sAPI from '../api/strapi.js'
export default {
  components: {
    // Toolbar: () => import(/* webpackChunkName: "cloud" */ '../ui/Toolbar.vue'),
    // BlueBubbles: () => import(/* webpackChunkName: "cloud" */ '../game/BlueBubbles.vue'),
    // BGTemplate: () => import(/* webpackChunkName: "cloud" */ '../game/BGTemplate.vue'),
    // GameLobby: () => import('../../../_cloud/v0-general/ui/GameLobby.vue')
  },
  data () {
    return {
      state: 'connecting',
      engine: false
    }
  },
  mounted () {
    let back = () => {
      this.state = 'email-taken'
      setTimeout(() => {
        this.$router.push('/cloud')
      }, 3000)
    }
    let checkFB = async () => {
      try {
        if (await sAPI.facebookArrive()) {
          this.$router.push('/cloud/choose-role')
        } else {
          back()
        }
      } catch (e) {
        console.log(e)
        back()
      }
    }
    let checkGoogle = async () => {
      try {
        if (await sAPI.googleArrive()) {
          this.$router.push('/cloud/choose-role')
        } else {
          back()
        }
      } catch (e) {
        console.log(e)
        back()
      }
    }
    let checkTwitter = async () => {
      try {
        if (await sAPI.twitterArrive()) {
          this.$router.push('/cloud/choose-role')
        } else {
          back()
        }
      } catch (e) {
        console.log(e)
        back()
      }
    }
    if (this.$route.meta.arrive === 'facebook') {
      checkFB()
    } else if (this.$route.meta.arrive === 'google') {
      checkGoogle()
    } else if (this.$route.meta.arrive === 'twitter') {
      checkTwitter()
    }
  }
}
</script>

<style>

</style>
